module.exports = __webpack_public_path__ + "static/img/fws_img_system.cd549a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/fws_img_system.png
// module id = Iend
// module chunks = 1